import { useState } from 'react';

import { type StatusOptions } from '../../../../common/types';

import { type UseFilters } from './types';

export const useFilters = (): UseFilters => {
	const [searchText, setSearchText] = useState('');
	const [statuses, setStatuses] = useState<StatusOptions>([]);

	return {
		searchText,
		statuses,
		handleSearchTextChange: setSearchText,
		handleStatusesChange: setStatuses,
	};
};
